import React, { useEffect } from "react";
import ContactsPanel from "../../comp/ContactsPanel";

export default function Contacts() {
  useEffect(() => { window.document.title = "通讯录"; }, []);
  return <ContactsPanel showHeader={true} leftWidth={440} />;
}
